

export class LineOperatorsModel {
    lineId: string;
    operatorCount: number;

    /**
     * 
     * @param lineId 
     * @param operatorCount 
     */
    constructor(lineId: string, operatorCount: number) {
        this.lineId = lineId;
        this.operatorCount = operatorCount;
    }
}